import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const HeaderStarIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22.24 7.92L16.34 6.91L13.56 1.61C12.97 0.38 11.05 0.37 10.46 1.61L7.68004 6.91L1.78004 7.92C0.420035 8.11 -0.169965 9.93 0.820035 10.88L5.00004 15.17L4.14004 21.1C3.90004 22.45 5.45004 23.57 6.65004 22.93L12.02 20.28L17.39 22.93C18.6 23.58 20.15 22.45 19.9 21.1L19.04 15.17L23.22 10.88C24.21 9.93 23.62 8.11 22.26 7.92H22.24ZM22.13 9.82L17.69 14.37C17.53 14.54 17.45 14.77 17.48 15L18.4 21.29C18.4 21.53 18.26 21.63 18.04 21.55L12.34 18.73C12.13 18.63 11.88 18.63 11.68 18.73L5.98004 21.55C5.75004 21.62 5.61003 21.52 5.62004 21.29L6.54004 15C6.57004 14.77 6.50004 14.54 6.33004 14.37L1.87004 9.82C1.73004 9.63 1.79004 9.46 2.01004 9.39L8.28004 8.32C8.51003 8.28 8.71004 8.14 8.82003 7.93L11.78 2.3C11.92 2.11 12.09 2.11 12.23 2.3L15.19 7.93C15.3 8.14 15.5 8.28 15.73 8.32L22 9.39C22.23 9.46 22.28 9.63 22.14 9.82H22.13Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HeaderStarIcon.displayName = 'HeaderStarIcon';
